import { useEffect, useState } from "react";

import AmplitudeProvider from "~/AmplitudeProvider";
import { GoogleColab as GoogleColabCard } from "./cards";

const STORAGE_KEY = "g_colab";
const CLOSE_CLICKED_EVENT = "algodash_google_colab_x_clicked";
const LINK_CLICKED_EVENT = "algodash_google_colab_clicked";

export const GoogleColab = () => {
  const [isShowing, setIsShowing] = useState(false);

  const onClose = () => {
    setIsShowing(false);
    window?.localStorage?.setItem(STORAGE_KEY, "1");
    AmplitudeProvider.dispatch(CLOSE_CLICKED_EVENT);
  };

  const onClickLink = () => AmplitudeProvider.dispatch(LINK_CLICKED_EVENT);

  useEffect(() => {
    if (!window?.localStorage?.getItem(STORAGE_KEY)) {
      setIsShowing(true);
    }
  }, []);

  if (!isShowing) {
    return null;
  }

  return <GoogleColabCard onClose={onClose} onClickLink={onClickLink} />;
};
